import { createPlaceholderToken } from './utils/placeholder-token';

export type PhraseExcludeOptions = {
  excludedPhrases?: string[];
  customFilter?: (value: string) => boolean;
};

const EXCLUSION_TOKEN_PREFIX = 'ELX';
const EXCLUSION_TOKEN_SUFFIX = 'X';

export function createPhraseExcludeHandler({
  excludedPhrases = [],
  customFilter = () => true
}: PhraseExcludeOptions = {}) {
  const processedExcludedPhrases = excludedPhrases
    .filter((value) => !!value.trim())
    .filter(customFilter)
    .sort((a, b) => b.length - a.length);

  const exclusionMapping: Record<string, string> = {};

  function exclude(originalPhrases: string[]) {
    return originalPhrases.map((phrase) => {
      let modifiedPhrase = phrase;

      processedExcludedPhrases.forEach((excluded) => {
        const id =
          exclusionMapping[excluded] ||
          createPlaceholderToken({
            prefix: EXCLUSION_TOKEN_PREFIX,
            value: excluded,
            suffix: EXCLUSION_TOKEN_SUFFIX
          });
        exclusionMapping[excluded] = id;

        const regex = new RegExp(escapeRegExp(excluded), 'g');
        modifiedPhrase = modifiedPhrase.replace(regex, id);
      });

      return modifiedPhrase;
    });
  }

  function restore(translatedPhrases: string[]) {
    return translatedPhrases.map((translatedPhrase) => {
      let restoredPhrase = translatedPhrase;

      Object.entries(exclusionMapping).forEach(([original, id]) => {
        const regex = new RegExp(escapeRegExp(id), 'g');
        restoredPhrase = restoredPhrase.replace(regex, original);
      });

      return restoredPhrase;
    });
  }

  return {
    exclude,
    restore
  };
}

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
